import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PopupActionsComponent } from './popup-actions.component';

@NgModule({
  declarations: [PopupActionsComponent],
  imports: [CommonModule],
  exports: [PopupActionsComponent]
})
export class PopupActionsModule {}
